
import { useState } from 'react';

export default function Product() {
  return (
    <div className="min-h-screen" style={{ 
      backgroundImage: `url('https://public.readdy.ai/ai/img_res/95f351ded1ecd3ac30a3a9cbf7dc8427.jpg')`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundAttachment: 'fixed'
    }}>
      {/* Header */}
      <header className="bg-white/90 backdrop-blur-sm border-b-4 border-red-500">
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center justify-center">
            <h1 className="text-3xl font-bold text-red-600" style={{ fontFamily: '"Pacifico", serif' }}>
              藤村屋入れ歯洗浄剤（歯科医院向け専用サイト）
            </h1>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="container mx-auto px-4 py-8">
        {/* Hero Section with Traditional House */}
        <section className="text-center mb-12">
          <div className="relative mx-auto max-w-4xl">
            <div 
              className="relative rounded-2xl overflow-hidden shadow-2xl border-4 border-red-500 bg-white/95 flex items-center justify-center"
              style={{ minHeight: '400px' }}
            >
              <div className="text-center p-8">
                <h2 className="text-6xl font-bold text-red-600 mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
                  藤村屋入れ歯洗浄剤
                </h2>
                <div className="bg-red-600 inline-block px-8 py-2 border-2 border-red-700">
                  <p className="text-white text-lg font-bold tracking-wider">初回販売100セット限定</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Special Campaign Section - NEW */}
        <section className="mb-8">
          <div className="bg-gradient-to-br from-red-500 to-red-600 rounded-2xl shadow-2xl border-4 border-yellow-400 p-8 text-center relative overflow-hidden">
            <div 
              className="absolute inset-0 opacity-20"
              style={{
                backgroundImage: `url('https://readdy.ai/api/search-image?query=Traditional%20Japanese%20festival%20fireworks%20and%20celebration%20decorations%2C%20gold%20and%20red%20colors%2C%20festive%20atmosphere%2C%20hand-drawn%20illustration%20style%2C%20sparkling%20effects%2C%20celebration%20background&width=800&height=400&seq=campaign001&orientation=landscape')`,
                backgroundSize: 'cover',
                backgroundPosition: 'center'
              }}
            ></div>
            <div className="relative z-10">
              <div className="bg-yellow-400 inline-block px-6 py-2 rounded-full mb-4 shadow-lg">
                <p className="text-red-600 font-bold text-lg">🎉 新発売記念特別企画 🎉</p>
              </div>
              <h3 className="text-3xl font-bold text-white mb-4">藤村Dサイン色紙プレゼント！</h3>
              <div className="bg-white/95 rounded-xl p-6 mb-6 shadow-lg">
                <p className="text-2xl font-bold text-red-600 mb-3">10セット（100袋）ご購入で</p>
                <div className="bg-gradient-to-r from-yellow-300 to-yellow-400 border-4 border-red-500 rounded-xl p-4 mb-3 shadow-xl transform hover:scale-105 transition-transform">
                  <p className="text-2xl font-black text-red-700 mb-2 animate-pulse">🎁 藤村忠寿さん直筆サイン色紙をプレゼント！ 🎁</p>
                  <div className="flex items-center justify-center">
                    <div className="bg-red-600 text-white px-4 py-2 rounded-full font-bold text-lg shadow-lg">
                      ✨ 超貴重！本人直筆 ✨
                    </div>
                  </div>
                </div>
                <div className="bg-red-100 border-2 border-red-400 rounded-lg p-3 inline-block">
                  <p className="text-red-700 font-bold text-lg">⚡ 先着5医院限定 ⚡</p>
                </div>
              </div>
              <a 
                href="https://pro.form-mailer.jp/fms/c391d54c340052"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-yellow-400 hover:bg-yellow-500 text-red-600 font-bold py-4 px-12 rounded-full text-xl shadow-lg transition-colors cursor-pointer whitespace-nowrap inline-block transform hover:scale-105"
              >
                今すぐ申し込む！
              </a>
            </div>
          </div>
        </section>

        {/* Product Section */}
        <section className="bg-gradient-to-br from-white/95 to-blue-50/90 backdrop-blur-sm rounded-2xl shadow-xl border-4 border-blue-500 p-8 mb-8">
          <div className="grid md:grid-cols-2 gap-8 items-center">
            <div className="text-center">
              <img 
                src="https://static.readdy.ai/image/90b8495d3de38d7de3b4d3abd2a2907e/d5e5f6890741f891037b9701eb605b0c.png"
                alt="藤村屋入れ歯洗浄剤パッケージ"
                className="w-full h-auto max-w-sm mx-auto rounded-lg shadow-lg"
              />
            </div>
            <div>
              <div>
                <h3 className="text-3xl font-bold text-red-600 mb-6">患者様に愛される話題の商品</h3>
                <div className="space-y-4 text-lg">
                  <p className="text-gray-700">
                    「水曜どうでしょう」でおなじみの藤村忠寿ディレクター本人がプロモーションに協力！患者様との会話のきっかけにもなり、自然に商品をおすすめできます。
                  </p>
                  <div className="bg-gradient-to-r from-red-50 to-red-100 p-4 rounded-lg border-l-4 border-red-500 shadow-sm">
                    <h4 className="font-bold text-red-700 mb-2">患者様への販売メリット</h4>
                    <ul className="space-y-2 text-red-600">
                      <li className="flex items-center">
                        <i className="ri-star-line text-yellow-500 mr-2"></i>
                        藤村Dファンの患者様に大変喜ばれます
                      </li>
                      <li className="flex items-center">
                        <i className="ri-chat-smile-line text-green-500 mr-2"></i>
                        話題性があり、患者様との会話が弾みます
                      </li>
                      <li className="flex items-center">
                        <i className="ri-heart-line text-pink-500 mr-2"></i>
                        本人監修の安心感で購入につながりやすい
                      </li>
                    </ul>
                  </div>
                  <div className="bg-gradient-to-r from-blue-50 to-blue-100 p-4 rounded-lg border-l-4 border-blue-500 shadow-sm">
                    <h4 className="font-bold text-blue-700 mb-2">製品の特徴</h4>
                    <ul className="space-y-2 text-blue-600">
                      <li className="flex items-center">
                        <i className="ri-check-line text-green-500 mr-2"></i>
                        洗浄後は酸素と水になるので自然に負荷をかけない
                      </li>
                      <li className="flex items-center">
                        <i className="ri-check-line text-green-500 mr-2"></i>
                        個別包装ではない顆粒タイプなので、量を調整できて経済的
                      </li>
                      <li className="flex items-center">
                        <i className="ri-check-line text-green-500 mr-2"></i>
                        店長の藤村忠寿ディレクターが企画・プロモーションに参加
                      </li>
                    </ul>
                  </div>
                  {/* CTA Button in Product Section */}
                  <div className="text-center mt-6">
                    <a 
                      href="https://pro.form-mailer.jp/fms/c391d54c340052"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="bg-red-600 hover:bg-red-7
                      00 text-white font-bold py-3 px-8 rounded-full text-lg shadow-lg transition-colors cursor-pointer whitespace-nowrap inline-block"
                    >
                      取り扱い申込はこちら
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Character Section */}
        <section className="bg-gradient-to-br from-white/95 to-yellow-50/90 backdrop-blur-sm rounded-2xl shadow-xl border-4 border-yellow-500 p-8 mb-8">
          <div className="text-center">
            <div 
              className="mx-auto w-64 h-64 rounded-full border-4 border-red-500 mb-6 shadow-lg"
              style={{
                backgroundImage: `url('https://static.readdy.ai/image/90b8495d3de38d7de3b4d3abd2a2907e/e8dda62330a65555af1da07672cf32cd.png')`,
                backgroundSize: 'cover',
                backgroundPosition: 'center'
              }}
            ></div>
            <h3 className="text-2xl font-bold text-blue-600 mb-4">藤村D店長からのメッセージ</h3>
            <div className="bg-gradient-to-r from-yellow-50 to-yellow-100 p-6 rounded-lg border-2 border-yellow-400 max-w-2xl mx-auto shadow-sm">
              <p className="text-lg text-gray-700 italic">
                「入れ歯になっても、人生もっと笑える」<br />
                入れ歯を使うことを恥じる時代は終わりしようじゃないか。入れ歯と共に笑って人生を楽しむ時代へと一緒に変えていこう。<br />
                まずは入れ歯洗浄剤からスタートだ。
              </p>
            </div>
            {/* CTA Button in Character Section */}
            <div className="mt-6">
              <a 
                href="https://pro.form-mailer.jp/fms/c391d54c340052"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-8 rounded-full text-lg shadow-lg transition-colors cursor-pointer whitespace-nowrap inline-block"
              >
                藤村Dと一緒に始める
              </a>
            </div>
          </div>
        </section>

        {/* Company Info */}
        <section className="bg-gradient-to-br from-white/95 to-green-50/90 backdrop-blur-sm rounded-2xl shadow-xl border-4 border-green-500 p-8">
          <div className="text-center">
            <h3 className="text-2xl font-bold text-green-600 mb-6">製造販売元</h3>
            <div className="bg-gradient-to-r from-green-50 to-green-100 p-6 rounded-lg border-2 border-green-400 max-w-md mx-auto shadow-sm">
              <h4 className="text-xl font-bold text-green-700 mb-4">株式会社お守り入れ歯</h4>
              <div className="space-y-2 text-green-600">
                <p className="flex items-center justify-center">
                  <i className="ri-global-line mr-2"></i>
                  <a href="https://omamoriireba.com/" target="_blank" rel="noopener noreferrer" className="hover:text-green-800 transition-colors cursor-pointer">
                    https://omamoriireba.com/
                  </a>
                </p>
                <p className="flex items-center justify-center">
                  <i className="ri-mail-line mr-2"></i>
                  お問い合わせはWebサイトから
                </p>
              </div>
            </div>
            {/* Final CTA Button */}
            <div className="mt-6">
              <a 
                href="https://omamoriireba.com/contact/"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-green-600 hover:bg-green-700 text-white font-bold py-4 px-10 rounded-full text-xl shadow-lg transition-colors cursor-pointer whitespace-nowrap inline-block"
              >
                お問い合わせ
              </a>
            </div>
          </div>
        </section>

      </main>

      {/* Floating Lanterns - REMOVED */}
    </div>
  );
}
